// CONSTANTS are all caps.
const NS = 'TopStickyNav';
const CLS = 'topStickyNav';
const WG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/portalProfileDropdown.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'

export class TopStickyNav {
	constructor($el) {
		// $el is the widget node return by the TopStickyNav function
		this.$el = $($el);
		this.$html = $('html');
	}

	init() {
		let links = this.$el.find('a');

		$(links).on('click', (e) => {
			if($('.topStickyNav .d-flex.d-lg-none').is(':visible')) {
this.$el.find('[data-toggle=\'collapse\']').trigger('click');
}
		});

		// heightMenuBlack MenuMiddle MenuScroll height
		let scrollPosition;

		let siteHeaderTopBarHeight = $('.siteHeaderTopBar').length > 0 
		? $('.siteHeaderTopBar')[0].getBoundingClientRect().height
		: $('.siteHeaderTopBarV2')[0].getBoundingClientRect().height;
		
		let	siteHeaderBottomHeight = $('.siteHeader-bottomWrapper').length > 0 
		? $('.siteHeader-bottomWrapper')[0].getBoundingClientRect().height
		: $('.siteHeaderV2-bottomWrapper')[0].getBoundingClientRect().height;
		let	topStickyNavHeight = $('.topStickyNav')[0].getBoundingClientRect().height;
 

		let sumHeight = siteHeaderTopBarHeight + siteHeaderBottomHeight + topStickyNavHeight + 12;
		// if(!$(".d-xl-none").is(':visible')){
		// 	sumHeight = topStickyNavHeight + 12;
		// }

 
		$('body').scrollspy({
			target: `#${CLS}Scrollspy`,
			offset: sumHeight, // <= 205 ? 210 : sumHeight
		});

		// $('.scroll-margin-nav').css('scroll-margin-top',$('.topStickyNav').outerHeight());
		if($('.topStickyNav .d-lg-none').is(':visible')) {
			$('.scroll-margin-nav').css('scroll-margin-top', 80 + $('.topStickyNav .nav-item').length * 64);
		} else if($('.d-xl-none').is(':visible')) {
				$('.scroll-margin-nav').css('scroll-margin-top', topStickyNavHeight + 12);
			}
		// setSize();


		let overviewBlockOffset;

		if ($(window).width() > 992) {
			overviewBlockOffset = $('.overviewBlock-nav').offset().top;
			$('.topStickyNav').css('top',siteHeaderTopBarHeight + siteHeaderBottomHeight);

		} else {
			overviewBlockOffset = 0;
		}

		$(window).on('resize', () => {

			let siteHeaderTopBarHeight = $('.siteHeaderTopBar').length > 0 
		? $('.siteHeaderTopBar')[0].getBoundingClientRect().height
		: $('.siteHeaderTopBarV2')[0].getBoundingClientRect().height;
		
		let	siteHeaderBottomHeight = $('.siteHeader-bottomWrapper').length > 0 
		? $('.siteHeader-bottomWrapper')[0].getBoundingClientRect().height
		: $('.siteHeaderV2-bottomWrapper')[0].getBoundingClientRect().height;
		let	topStickyNavHeight = $('.topStickyNav')[0].getBoundingClientRect().height;

			if(overviewBlockOffset === 0) {
				this.$el.removeClass(`${CLS}-shown`);
			}


			if ($(window).width() >= 1200) {
				overviewBlockOffset = $('.overviewBlock-nav').offset().top;
				$('.topStickyNav').css('top',siteHeaderTopBarHeight + siteHeaderBottomHeight);

			} else {
				overviewBlockOffset = 0;
				this.$el.addClass(`${CLS}-shown`);
				$('.topStickyNav').css('top',0);
			}


			if($('.topStickyNav .d-lg-none').is(':visible')) {
				$('.scroll-margin-nav').css('scroll-margin-top', 80 + $('.topStickyNav .nav-item').length * 64);
			} else if($('.d-xl-none').is(':visible')) {
					$('.scroll-margin-nav').css('scroll-margin-top', topStickyNavHeight + 12);
				} else{
					$('.scroll-margin-nav').css('scroll-margin-top', sumHeight);
				}
		});

		$(window).on('scroll', () => {
			scrollPosition = $(window).scrollTop();

			if (scrollPosition >= overviewBlockOffset) {
				this.$el.addClass(`${CLS}-shown`);
				$('.popupAlertWidget[data-closed=\'false\']').hide();
			} else {
				this.$el.removeClass(`${CLS}-shown`);
				$('.popupAlertWidget[data-closed=\'false\']').show();
			}
		});

		if ($(window).scrollTop() >= overviewBlockOffset) {
			this.$el.addClass(`${CLS}-shown`);
		}
	}

	// setSize(){
	// 	if($(".topStickyNav .d-lg-none").is(':visible')){
	// 		$(".scroll-margin-nav").css('scroll-margin-top',80 + $('.topStickyNav .nav-item').length * 64);
	// 	}
	// 	else if($(".d-xl-none").is(':visible')){
	// 			$(".scroll-margin-nav").css('scroll-margin-top',$(".topStickyNav")[0].getBoundingClientRect().height + 12);
	// 		}
	// }
}
